module.exports = __webpack_public_path__ + "img/msteam-addin-04.b812d142.png";